export default __webpack_public_path__ + "static/media/passed_icon.39fa8f53.svg";